/* eslint-enable */

class AnimationHeroDigitalIt {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.$moduleHeroImageOverflow = this.sectionsContainer.querySelector('.hero-image-overflow');
        
        if (!this.$moduleHeroImageOverflow) return;
        
        this.$moduleHeroImageOverflowElements = this.$moduleHeroImageOverflow.querySelectorAll('.anima');
        
        this.init();
    }

    init() {
        this.setAnimation();
    }

    setAnimation() {
        gsap.set(this.$moduleHeroImageOverflow, { opacity: 1 }); // Mejor usar opacity 0
        gsap.set(this.$moduleHeroImageOverflowElements, { yPercent: 100, opacity: 0, onComplete: () => this.initAnimate() });
    }

    initAnimate() {
        this.animateHeroInsight = gsap.timeline({
            defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleHeroImageOverflow,
                start: 'top 100%', // Ajusta esto según lo que necesites
                //toggleActions: 'play none none none'
            },
            onComplete: () => {
                gsap.set(this.$moduleHeroImageOverflowElements, { clearProps: true });
            }
        });
    
        this.animateHeroInsight.addLabel('step1');
        this.animateHeroInsight.to(this.$moduleHeroImageOverflow, { opacity: 1, duration: 0 }, 'step1');
        this.animateHeroInsight.to(this.$moduleHeroImageOverflowElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
    }
}

export default AnimationHeroDigitalIt;
